import { AframeListener } from '@/component/ARGame/ARCategory/js/aframeListener';
import { loadScript } from '@/util/dom';
import { useEffect, useState } from 'react';

type useAframeSceneLoadProps = {
  scripts: Array<{ uri: string }>;
  onSceneLoad: () => void;
};
const useAframeSceneLoad = ({
  scripts,
  onSceneLoad,
}: useAframeSceneLoadProps) => {
  const [isScriptLoaded, setScriptLoaded] = useState(false);
  const [isAframeListenerLoaded, setIsAframeListenerLoaded] = useState(false);

  const onLoadScripts = async () => {
    for (const script of scripts) {
      await loadScript(script.uri);
    }
    setScriptLoaded(true);
  };
  useEffect(() => {
    onLoadScripts();
  }, []);
  useEffect(() => {
    if (!isScriptLoaded) return;
    if (isAframeListenerLoaded) {
      const scene: any = document.querySelector('a-scene');
      if (scene && scene.hasLoaded) {
        onSceneLoad();
      } else if (scene) {
        scene.addEventListener('loaded', onSceneLoad);
      }
    }
    if (!isAframeListenerLoaded) {
      new AframeListener();
      setIsAframeListenerLoaded(true);
    }
  }, [isAframeListenerLoaded, isScriptLoaded]);

  return { isLoaded: isAframeListenerLoaded };
};

export { useAframeSceneLoad };
